import { render, staticRenderFns } from "./ApplicantDisclosures.vue?vue&type=template&id=1e856482&scoped=true&"
import script from "./ApplicantDisclosures.vue?vue&type=script&lang=js&"
export * from "./ApplicantDisclosures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e856482",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e856482')) {
      api.createRecord('1e856482', component.options)
    } else {
      api.reload('1e856482', component.options)
    }
    module.hot.accept("./ApplicantDisclosures.vue?vue&type=template&id=1e856482&scoped=true&", function () {
      api.rerender('1e856482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/components/Apply/ApplicantDisclosures.vue"
export default component.exports